import { cn } from '#/shared/lib/utils'
import { PencilIcon } from '#/shared/ui/icons'

export function SectionEditButton({
  label,
  onClick,
  groupName = 'section',
}: {
  label: string
  onClick: () => void
  groupName?: 'section' | 'notes'
}) {
  return (
    <button
      type="button"
      aria-label={label}
      onClick={onClick}
      className={cn(
        'absolute top-1 right-1 flex size-6 cursor-pointer items-center justify-center rounded-md border border-gray-200 bg-white text-gray-500 opacity-0 hover:bg-gray-50',
        groupName === 'notes'
          ? 'group-hover/notes:opacity-100'
          : 'group-hover/section:opacity-100',
      )}
    >
      <PencilIcon className="size-3" />
    </button>
  )
}
